import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withKeys as _withKeys, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d2bee9e")

_pushScopeId("data-v-6d2bee9e")
const _hoisted_1 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  "aria-hidden": "true",
  class: "fixed inset-0 transition-opacity"
}, [
  /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true",
  class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1)
const _hoisted_4 = {
  "aria-labelledby": "modal-headline",
  "aria-modal": "true",
  class: "inline-block align-bottom bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
  role: "dialog"
}
const _hoisted_5 = { class: "bg-gray-100 px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_6 = { class: "sm:flex sm:items-start" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10" }, [
  /*#__PURE__*/_createVNode("svg", {
    "aria-hidden": "true",
    class: "h-6 w-6 text-red-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_8 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_9 = {
  id: "modal-headline",
  class: "text-lg leading-6 font-medium text-gray-900"
}
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "text-sm text-gray-500" }
const _hoisted_12 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showButton === true)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)))
        }, _toDisplayString(_ctx.dialogTitle), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.hideDialog && _ctx.hideDialog(...args)), ["esc"]))
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                _createVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("modal.DeleteConfirmDialog.dialogTitle")), 1),
                _createVNode("div", _hoisted_10, [
                  _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("modal.DeleteConfirmDialog.dialogDescription")), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("button", {
              class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, _toDisplayString(_ctx.$t("modal.DeleteConfirmDialog.confirmButtonText")), 1),
            _createVNode("button", {
              class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-gray-100 text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)))
            }, _toDisplayString(_ctx.$t("modal.DeleteConfirmDialog.cancelButtonText")), 1)
          ])
        ])
      ])
    ], 544), [
      [_vShow, _ctx.dialogVisible]
    ])
  ], 64))
})